import React from 'react'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router-dom'
import { CustomizedSnackbar } from '../../containers'
import { MenuAppBar } from '../../Parts/MenuAppBar'
import Settings from './containers/Settings'
import SettingsMenu from './containers/SettingsMenu'
import { LANGUAGE_SHORT_CODE } from '../../constants';
import Word from '../../containers/Common/Word';
import { WID } from '../../constants/Language'

class SettingsRouting extends React.Component {
  render() {
    var regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => LANGUAGE_SHORT_CODE[key]).join('|')

    return (
      <React.Fragment>
        <MenuAppBar title={<Word wid={WID.MENU_APP_BAR.SETTINGS}/>} actions={<SettingsMenu/>}/>
        <Switch>
          <Route exact path={`/:language(${regstr})/settings`} component={Settings}/>
          <Route path={`/:language(${regstr})/settings/:menuItemName`} component={Settings} />

          <Route exact path='/settings' component={Settings}/>
          <Route path='/settings/:menuItemName' component={Settings} />
        </Switch>
        <CustomizedSnackbar/>
      </React.Fragment>
    )
  }
}

export default (SettingsRouting)



// WEBPACK FOOTER //
// ./src/Pages/Settings/SettingsRouting.js